
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-58f8801b!postcss-loader?sourceMap!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./dialog.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./dialog.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-58f8801b!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./dialog.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/plugin/components/dialog.vue
// module id = 51
// module chunks = 0